// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: DGii8JbubKdz
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateStateOnChangeProp,
  generateStateValueProp,
  hasVariant,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { useScreenVariants as useScreenVariantseuyRl26Gw8Ft } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: EuyRl26Gw8Ft/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicDebtorContact.module.css"; // plasmic-import: DGii8JbubKdz/css

createPlasmicElementProxy;

export const PlasmicDebtorContact__VariantProps = new Array();

export const PlasmicDebtorContact__ArgProps = new Array();

const $$ = {};

function PlasmicDebtorContact__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "contactName.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "contactPhone.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "contactEmail.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantseuyRl26Gw8Ft()
  });
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root
      )}
    >
      <div className={classNames(projectcss.all, sty.freeBox__pkxZ)}>
        <div className={classNames(projectcss.all, sty.freeBox__qR02E)}>
          <div
            data-plasmic-name={"contactNameText"}
            data-plasmic-override={overrides.contactNameText}
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.contactNameText
            )}
          >
            {"Contact Name"}
          </div>
          <div
            data-plasmic-name={"deleteField"}
            data-plasmic-override={overrides.deleteField}
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.deleteField
            )}
          >
            {"X"}
          </div>
        </div>
        <input
          data-plasmic-name={"contactName"}
          data-plasmic-override={overrides.contactName}
          className={classNames(
            projectcss.all,
            projectcss.input,
            sty.contactName
          )}
          onChange={async (...eventArgs) => {
            (e => {
              generateStateOnChangeProp($state, ["contactName", "value"])(
                e.target.value
              );
            }).apply(null, eventArgs);
          }}
          placeholder={"Full Name"}
          ref={ref => {
            $refs["contactName"] = ref;
          }}
          size={1}
          type={"text"}
          value={generateStateValueProp($state, ["contactName", "value"]) ?? ""}
        />

        <div
          data-plasmic-name={"contactNameError"}
          data-plasmic-override={overrides.contactNameError}
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.contactNameError
          )}
        >
          {hasVariant(globalVariants, "screen", "small") ? (
            <React.Fragment>
              <span
                className={"plasmic_default__all plasmic_default__span"}
                style={{ color: "#FF0000" }}
              >
                {"At least one phone number or email is required"}
              </span>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <span
                className={"plasmic_default__all plasmic_default__span"}
                style={{ color: "#FF0000" }}
              >
                {"Contact Name is a required field"}
              </span>
            </React.Fragment>
          )}
        </div>
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__i9U5Q)}>
        <div
          data-plasmic-name={"contactPhoneText"}
          data-plasmic-override={overrides.contactPhoneText}
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.contactPhoneText
          )}
        >
          {"Contact Phone Number"}
        </div>
        <input
          data-plasmic-name={"contactPhone"}
          data-plasmic-override={overrides.contactPhone}
          className={classNames(
            projectcss.all,
            projectcss.input,
            sty.contactPhone
          )}
          onChange={async (...eventArgs) => {
            (e => {
              generateStateOnChangeProp($state, ["contactPhone", "value"])(
                e.target.value
              );
            }).apply(null, eventArgs);
          }}
          placeholder={``}
          ref={ref => {
            $refs["contactPhone"] = ref;
          }}
          size={1}
          type={"text"}
          value={
            generateStateValueProp($state, ["contactPhone", "value"]) ?? ""
          }
        />

        <div
          data-plasmic-name={"contactPhoneError"}
          data-plasmic-override={overrides.contactPhoneError}
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.contactPhoneError
          )}
        >
          {hasVariant(globalVariants, "screen", "small") ? (
            <React.Fragment>
              <span
                className={"plasmic_default__all plasmic_default__span"}
                style={{ color: "#FF0000" }}
              >
                {"At least one phone number or email is required"}
              </span>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <span
                className={"plasmic_default__all plasmic_default__span"}
                style={{ color: "#FF0000" }}
              >
                {"At least one phone number or email is required"}
              </span>
            </React.Fragment>
          )}
        </div>
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__avJm6)}>
        <div
          data-plasmic-name={"contactEmailText"}
          data-plasmic-override={overrides.contactEmailText}
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.contactEmailText
          )}
        >
          {"Contact Email"}
        </div>
        <input
          data-plasmic-name={"contactEmail"}
          data-plasmic-override={overrides.contactEmail}
          className={classNames(
            projectcss.all,
            projectcss.input,
            sty.contactEmail
          )}
          onChange={async (...eventArgs) => {
            (e => {
              generateStateOnChangeProp($state, ["contactEmail", "value"])(
                e.target.value
              );
            }).apply(null, eventArgs);
          }}
          placeholder={``}
          ref={ref => {
            $refs["contactEmail"] = ref;
          }}
          size={1}
          type={"text"}
          value={
            generateStateValueProp($state, ["contactEmail", "value"]) ?? ""
          }
        />

        <div
          data-plasmic-name={"contactEmailError"}
          data-plasmic-override={overrides.contactEmailError}
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.contactEmailError
          )}
        >
          {hasVariant(globalVariants, "screen", "small") ? (
            <React.Fragment>
              <span
                className={"plasmic_default__all plasmic_default__span"}
                style={{ color: "#FF0000" }}
              >
                {"At least one phone number or email is required"}
              </span>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <span
                className={"plasmic_default__all plasmic_default__span"}
                style={{ color: "#FF0000" }}
              >
                {"At least one phone number or email is required"}
              </span>
            </React.Fragment>
          )}
        </div>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "contactNameText",
    "deleteField",
    "contactName",
    "contactNameError",
    "contactPhoneText",
    "contactPhone",
    "contactPhoneError",
    "contactEmailText",
    "contactEmail",
    "contactEmailError"
  ],

  contactNameText: ["contactNameText"],
  deleteField: ["deleteField"],
  contactName: ["contactName"],
  contactNameError: ["contactNameError"],
  contactPhoneText: ["contactPhoneText"],
  contactPhone: ["contactPhone"],
  contactPhoneError: ["contactPhoneError"],
  contactEmailText: ["contactEmailText"],
  contactEmail: ["contactEmail"],
  contactEmailError: ["contactEmailError"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicDebtorContact__ArgProps,
          internalVariantPropNames: PlasmicDebtorContact__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicDebtorContact__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicDebtorContact";
  } else {
    func.displayName = `PlasmicDebtorContact.${nodeName}`;
  }
  return func;
}

export const PlasmicDebtorContact = Object.assign(
  // Top-level PlasmicDebtorContact renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    contactNameText: makeNodeComponent("contactNameText"),
    deleteField: makeNodeComponent("deleteField"),
    contactName: makeNodeComponent("contactName"),
    contactNameError: makeNodeComponent("contactNameError"),
    contactPhoneText: makeNodeComponent("contactPhoneText"),
    contactPhone: makeNodeComponent("contactPhone"),
    contactPhoneError: makeNodeComponent("contactPhoneError"),
    contactEmailText: makeNodeComponent("contactEmailText"),
    contactEmail: makeNodeComponent("contactEmail"),
    contactEmailError: makeNodeComponent("contactEmailError"),
    // Metadata about props expected for PlasmicDebtorContact
    internalVariantProps: PlasmicDebtorContact__VariantProps,
    internalArgProps: PlasmicDebtorContact__ArgProps
  }
);

export default PlasmicDebtorContact;
/* prettier-ignore-end */
